import React, { useEffect, useState } from 'react';
import { CircularProgress, Typography } from '@material-ui/core';
import {
  useStyles,
  ChildProjectsService,
  ChildProjectsListLogic,
} from './ChildProjectsService.module';

const ChildProjectsList = ({ projectId }) => {
  const classes = useStyles();
  const { getChildProjects } = ChildProjectsService();
  const { translator, goToDmrv } = ChildProjectsListLogic();

  const [childProjects, setChildProjects] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!projectId) {
      setIsLoading(false);
      return;
    }

    const fetchChildProjects = async () => {
      setIsLoading(true);
      setError(null);

      try {
        const { childProjects } = await getChildProjects(projectId);
        setChildProjects(childProjects);
      } catch (err) {
        console.error('Error cargando proyectos hijos:', err);
        setError(true);
      } finally {
        setIsLoading(false);
      }
    };

    fetchChildProjects();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectId]);

  if (isLoading) {
    return (
      <div className={classes.loadingContainer}>
        <CircularProgress />
      </div>
    );
  }

  if (error || childProjects.length === 0) {
    return null;
  }

  return (
    <div className={classes.container}>
      <Typography variant="h5" className={classes.sectionTitle}>
        {translator('childProjectsList.title')}
      </Typography>
      <div className={classes.chipList}>
        {childProjects.map((project, index) => (
          <span
            key={project._id || index}
            className={classes.chip}
            onClick={(e) => goToDmrv(e, project.owner)}
            style={{ cursor: 'pointer' }}
          >
            {project?.info?.en?.name || project?.project_name || ''}
          </span>
        ))}
      </div>
    </div>
  );
};

export default ChildProjectsList;
